import React from 'react';
import NewSelector, { BaseSelectItem } from './NewSelector'; // NewSelector'ı import et
import api from '../utils/api';
// CreateFabricPage yerine CreateFabric import edilecek
import CreateFabric from '../pages/CreateFabric'; // Kumaş oluşturma sayfası
import { Tag } from 'antd'; // Tag gibi UI bileşenleri gerekebilir

// Fabric arayüzü BaseSelectItem'i genişletmeli
export interface Fabric extends BaseSelectItem {
  // _id ve name BaseSelectItem'den gelir
  code?: string; // Kumaş kodu
  description?: string;
  // Kumaşa özgü diğer alanlar buraya eklenebilir
  // Örneğin: type, supplier, composition vb.
  type?: string;
  composition?: string;
  supplier?: string;
}

interface FabricSelectorProps {
  selectedFabric: Fabric | null;
  onFabricSelect: (fabric: Fabric | null) => void;
  className?: string;
}

const fetchAllFabrics = async (): Promise<Fabric[]> => {
  const response = await api.get('/fabrics'); // Kumaşlar için API endpoint'i
  return response.data || [];
};

// Select.Option içeriğini özel olarak render etmek için fonksiyon (isteğe bağlı)
const renderFabricOption = (fabric: Fabric) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <div>
      <span>{fabric.name}</span>
      {fabric.code && <span style={{ marginLeft: 8, color: '#888' }}>({fabric.code})</span>}
    </div>
    {fabric.type && <Tag color="blue">{fabric.type}</Tag>}
  </div>
);

const FabricSelector: React.FC<FabricSelectorProps> = ({ selectedFabric, onFabricSelect, className }) => {
  return (
    <NewSelector<Fabric>
      selectedItem={selectedFabric}
      onItemSelected={onFabricSelect}
      fetchItems={fetchAllFabrics}
      createItemComponent={CreateFabric} // CreateFabricPage yerine CreateFabric kullan
      itemKeyField="_id" // Kumaş objesindeki ID alanı
      itemLabelField="name" // Kumaş objesindeki etiket alanı
      searchFields={['name', 'code', 'type', 'composition']} // Arama yapılacak alanlar
      renderItemOption={renderFabricOption} // Özel render fonksiyonu
      modalTitle="Yeni Kumaş Oluştur"
      placeholder="Kumaş seçin veya arayın"
      createButtonText="Yeni Kumaş Ekle"
      className={className}
      allowClear={true} // Kumaş seçimini temizlemeye izin ver
    />
  );
};

export default FabricSelector;
